import { writable } from 'svelte/store';
const faceTrackingStore = writable({
    loading: false,
    trackingProgress: 0,
    compileProgress: 0,
    videosSegmentedProgress: false,
    data: null,
    video: null,
    v2: true,
    faceSelection: false,
    facialEncodings: null
});
export default faceTrackingStore;
